import React, { useState } from 'react';
import { DemoRequestModal } from './DemoRequestModal';
import { WhatsAppModal } from './WhatsAppModal';
import { BookingModal } from './BookingModal';
import { SEO, SEOConfig } from './SEO';
import { MainFooter } from './Footer';
import { Header } from './Header';
import ScrollToTopButton from './ScrollToTopButton';

// Import all section components
import HeroSection from './sections/HeroSection';
import FeaturesSection from './sections/FeaturesSection';
import IDAComplianceSection from './sections/IDAComplianceSection';
import RealWorldExampleSection from './sections/RealWorldExampleSection';
import AuditSection from './sections/AuditSection';
import TrainingCenterSection from './sections/TrainingCenterSection';
// import RiskRewardSection from './sections/RiskRewardSection'; // TEMPORARILY DISABLED
import IndustriesSection from './sections/IndustriesSection';
import PricingSection from './sections/PricingSection';
import FAQSection from './sections/FAQSection';
import NewsSection from './sections/NewsSection';

export const HomePage = () => {
  const [demoModalOpen, setDemoModalOpen] = useState(false);
  const [preselectedIndustry, setPreselectedIndustry] = useState('');
  const [whatsappModalOpen, setWhatsappModalOpen] = useState(false);
  const [bookingModalOpen, setBookingModalOpen] = useState(false);

  const handleOpenDemo = (industry) => {
    // Mapping der Branchen-Namen zu den Demo-Modal Optionen
    const industryMapping = {
      'Spielhallen': 'Spielhalle',
      'Wettbüro': 'Wettbüro',
      'Gastronomie': 'Gastronomie mit Geldspielgeräten',
      'Andere Branche': 'Sonstige'
    };

    setPreselectedIndustry(industryMapping[industry] || 'Sonstige');
    setDemoModalOpen(true);
  };

  return (
    <>
      <SEO {...SEOConfig.homepage} />
      <div className="min-h-screen bg-white">
      <Header showActions={true} />

      {/* Hero Section */}
      <HeroSection />

      {/* Features Section */}
      <FeaturesSection />

      {/* IDA Compliance Section */}
      <IDAComplianceSection />

      {/* Real World Example Section */}
      <RealWorldExampleSection />

      {/* Audit Section (includes Benefits) */}
      <AuditSection />

      {/* Training Center Section */}
      <TrainingCenterSection />

      {/* TEMPORARILY DISABLED: Risk & Reward Section */}
      {/* <RiskRewardSection /> */}

      {/* Industries Section (Bedarfsanalyse) */}
      <IndustriesSection onOpenDemo={handleOpenDemo} />

      {/* Pricing Section */}
      <PricingSection />

      {/* FAQ Section */}
      <FAQSection />

      {/* News Section */}
      <NewsSection />

      <MainFooter />

      {/* Modals */}
      <DemoRequestModal
        isOpen={demoModalOpen}
        setIsOpen={setDemoModalOpen}
        preselectedIndustry={preselectedIndustry}
      />
      <WhatsAppModal isOpen={whatsappModalOpen} setIsOpen={setWhatsappModalOpen} />
      <BookingModal isOpen={bookingModalOpen} setIsOpen={setBookingModalOpen} />

      {/* Scroll to Top Button with Progress Indicator */}
      <ScrollToTopButton />
    </div>
    </>
  );
};

export default HomePage;
